export const globalConstants = {
  footerLinks: [
    { link: `Help`, url: 'http://www.monash.edu/students/cost-relief', target: "_blank" },
    { link: `Terms & Conditions`, url: 'https://www.vaultps.com.au/monashunicardterms/', target: "_blank" },
  ],
  iconLabel1: '## 1. Receive',
  iconLabel2: '## 2. Activate',
  iconLabel3: '## 3. Spend',
  expiredCardMessage: `Unfortunately the activation period on your card has expired. Per the instructions accompanying the card, your card needed to be activated within the specified timeframe. Click here (${process.env.REACT_APP_TERMS_LINK}) for full terms and conditions`,
};
